

export const configTracking = {
   mixpanelTrakingId: '4a128d71915362e29c9af2a5e302f68c',
   gaTrakingId: 'G-N9GTML89YS',
   isDebug: process.env.NODE_ENV === 'development',
   gaEnabled: false,
   mixpanelEnabled: true
}
